import { type Route } from "@sg-protect/federation-runtime";
import { NestedErrorBoundary } from "@sg-protect/shell";
import { redirect } from "react-router";
import { acquireMsalManagementToken } from "./api/auth/msalManagement.ts";
import { fetchConsent } from "./api/routes/consent.ts";
import { AuthenticatedLayout } from "./components/layout/AuthenticatedLayout.tsx";
import { ArchivesRoutes } from "./constants.ts";

const requireManagementAuth = async () => {
    if (process.env.APP_ENV === "msw") {
        return null;
    }

    try {
        await acquireMsalManagementToken();
        const { data } = await fetchConsent();

        if (!data?.isConsented) {
            throw new Error("User is not consented");
        }

        return null;
    } catch {
        const currentPathAndQuery = window.location.pathname + window.location.search;

        return redirect(`/archives/auth?onConnectedRedirectUri=${encodeURIComponent(currentPathAndQuery)}`);
    }
};

export const privateRoutes: Route[] = [
    {
        element: <AuthenticatedLayout />,
        errorElement: <NestedErrorBoundary />,
        shouldRevalidate: () => true,
        children: [
            {
                index: true,
                lazy: () => import("./pages/archives.tsx"),
                loader: requireManagementAuth,
                handle: {
                    trackingName: "Archives Page"
                }
            },
            {
                path: ArchivesRoutes.registration.archivesDetails,
                lazy: () => import("./pages/archives.[workspaceId].tsx"),
                loader: requireManagementAuth,
                handle: {
                    trackingName: "Archives / Details Page"
                }
            },
            {
                path: ArchivesRoutes.registration.auth,
                lazy: () => import("./pages/authenticate.tsx"),
                handle: {
                    trackingName: "Archives / Auth Page"
                }
            }
        ]
    }
];
